import { Injectable, Injector } from '@angular/core';
import { Subject, timer, Subscription, forkJoin } from 'rxjs';
import moment from 'moment';
import { IllumLiveService } from './illum-live.service';
import { DeviceService } from './device.service';
import _ from 'lodash';
import { CoresService } from './cores.service';
import * as Cesium from 'cesium';
@Injectable({
  providedIn: 'root',
})
export class ArcAngelNotificationsService {
  private readonly PERIMETER_USER_COUNT_STATUS_SOME_USERS =
    'PERIMETER_USER_COUNT_STATUS_SOME_USERS';
  private readonly PERIMETER_USER_COUNT_STATUS_NO_USERS =
    'PERIMETER_USER_COUNT_STATUS_NO_USERS';
  private readonly PERIMETER_SAFETY_STATUS_SAFE =
    'PERIMETER_SAFETY_STATUS_SAFE';
  private readonly PERIMETER_SAFETY_STATUS_UNSAFE =
    'PERIMETER_SAFETY_STATUS_UNSAFE';
  private readonly PERIMETER_SAFETY_STATUS_UNKNOWN =
    'PERIMETER_SAFETY_STATUS_UNKNOWN';
  perimeterUserCountStatus = 'PERIMETER_USER_COUNT_STATUS_SOME_USERS';
  perimeterSafetyStatus = 'PERIMETER_USER_COUNT_STATUS_SOME_USERS';
  perimeterSafetyStatusLast = 'PERIMETER_USER_COUNT_STATUS_SOME_USERS';

  private foreverPollerSubscription: Subscription | undefined;

  private activeIncidents: Record<string, boolean> = {};
  private pendingIncidents: Record<string, boolean> = {};
  private procalls: Record<string, boolean> = {};
  private procallNotifications: Record<string, boolean> = {};
  private missedTrackingIds: Record<string, any> = {};
  private panicTrackingIds: Record<string, any> = {};
  private trackingIds: Record<string, any> = {};
  private combinedIds: Record<string, any> = {};
  private modesService: any;

  // Notification event stream
  public notification$ = new Subject<any>();
  transparency = 0.3;
  material: Cesium.Color | undefined;
  constructor(
    private illumLiveService: IllumLiveService,
    private deviceService: DeviceService,
    private cores: CoresService,
  ) 
  {}
  startNotificationsService(service?: any): void {
    this.modesService = service;
    //this.foreverPoller();
  }

  stopNotificationsService(): void {
    if (this.foreverPollerSubscription) {
      this.foreverPollerSubscription.unsubscribe();
    }
  }

  private foreverPoller(): void {
    // Replace with actual service calls and forkJoin
    // Example:
    forkJoin([
      this.illumLiveService.getAllIncidents('active,pending'),
      this.illumLiveService.getAllProcalls(false),
      this.illumLiveService.getCurrentActiveTrackingEvents(),
    ]).subscribe({
      next: ([eventData, procallData, trackingData]) => {
        /////////  ToDo
        this.parseCurrentIncidents(eventData);
        this.parseCurrentTrackingAndProcalls(trackingData, procallData);
      },
      error: (error) => {
        // handle error
      },
    });

    // For polling every 3 seconds:
    this.foreverPollerSubscription = timer(0, 3000).subscribe(() => {
      this.foreverPoller();
    });
  }

  // parseCurrentIncidents(eventData: any[], procallData : any, trackingData : any): void {
  //   this.parseCurrentTrackingAndProcalls(trackingData, procallData);
  parseCurrentIncidents(eventData: any[]): void {
    const activePendingEventIds: Record<string, boolean> = {};
    // eslint-disable-next-line @typescript-eslint/prefer-for-of
    for (let i = 0; i < eventData.length; i++) {
      const incident = eventData[i];

      if (!incident.isMuster) {
        if (
          incident.status === 'active' &&
          !(incident.id in this.activeIncidents)
        ) {
          if (incident.id in this.pendingIncidents) {
            this.broadcastNotificationRemoval(incident.id);
          }

          this.activeIncidents[incident.id] = true;

          this.broadcastActiveIncidentNotification(
            incident.id,
            incident.label,
            incident.description,
            incident.createdAt
          );
        } else if (
          incident.status === 'PENDING' &&
          !(incident.id in this.pendingIncidents)
        ) {
          this.pendingIncidents[incident.id] = true;

          this.broadcastPendingIncidentNotification(
            incident.id,
            incident.label,
            incident.description,
            incident.createdAt
          );
        }

        activePendingEventIds[incident.id] = true;
        // const mode = this.sessionOptionsService.getMode();
        // if (mode !== 'Playback Mode') {
        //   this.deviceService.getCountDevicesByPerimeterAndStatus(incident.id).subscribe(x=>{});
        //   this.illumLiveService.updatePerimeterSafetyStatus(incident.id, 1);
        // }
       this.illumLiveService.updatePerimeterSafetyStatus(incident.id, 1);
        // if (!this.sessionOptionsService.isPlaybackMode()) {
        //   this.arcAngelService.methods.bulkUpdateDevices();
        // }
      }
    }

    let keys: string[] = [];
    Object.keys(this.activeIncidents).forEach((key) => {
      if (!(key in activePendingEventIds)) {
        this.broadcastNotificationRemoval(key);
        delete this.deviceService.data.userStatusByIncident[key];
        this.resetPerimeterForBuildings();
        keys.push(key);
      }
    });
    keys.forEach((key) => {
      delete this.activeIncidents[key];
    });

    keys = [];
    Object.keys(this.pendingIncidents).forEach((key) => {
      if (!(key in activePendingEventIds)) {
        this.broadcastNotificationRemoval(key);
        delete this.deviceService.data.userStatusByIncident[key];
        this.resetPerimeterForBuildings();
        keys.push(key);
      }
    });
    keys.forEach((key) => {
      delete this.pendingIncidents[key];
    });
  }

  private resetPerimeterForBuildings(): void {
    _.forEach(this.deviceService.data.myBuildings, (building) => {
      building.resetPerimeterSafetyStatus();
    });
  }

  private parseCurrentTrackingAndProcalls(
    trackingData: any[],
    procallData: any[]
  ): void {
    // ...existing logic...
  }

  private isInBothTrackingAndProcall(
    profileId: string,
    trackingData: any[],
    procallData: any[]
  ): boolean {
    // ...existing logic...
    return false;
  }

  private getMatchingProcall(profileId: string, procallData: any[]): any {
    // ...existing logic...
    return null;
  }

  private buildNotificationContentString(
    type: string,
    name: string,
    description: string,
    timestamp: any
  ): string {
    return `<strong>${name}</strong><br>${description}<br>Reported on ${moment(
      timestamp
    ).format('dddd MMM DD hh:mm a')}`;
  }

  private buildProcallContentString(
    status: string,
    title: string,
    timestamp: any
  ): string {
    if (!title || title.length < 1) {
      title = 'Unknown User';
    }
    return `<strong> ${this.capitalizeFirstLetter(
      status
    )} Procall</strong><br>${title}<br>${moment(timestamp).format(
      'dddd MMM DD hh:mm:ss'
    )}`;
  }

  private buildTrackingContentString(
    item: any,
    name: string,
    timestamp: any,
    missed: boolean,
    indistress: boolean
  ): string {
    let title = 'Active Tracking';
    if (indistress) {
      title = 'User triggered Active Tracking panic button';
    } else if (missed) {
      title = 'Active Tracking has ended';
    }
    return `<strong> ${title} </strong><br>${name}<br>Tracking started: ${moment(
      new Date(item.begin).getTime()
    ).format('MMM DD hh:mm:ss')}<br>`;
  }

  private buildCombinedContentString(
    trackingData: any,
    procallData: any
  ): string {
    const title = 'Procall While Tracking';
    return `<strong> ${title} </strong><br>${
      trackingData.title
    }<br>Tracking started: ${moment(
      new Date(trackingData.begin).getTime()
    ).format('MMM DD hh:mm:ss')}<br>Tracking will end: ${moment(
      new Date(trackingData.end).getTime()
    ).format('MMM DD hh:mm:ss')}<br>Procall started: ${moment(
      new Date(procallData.startedAt).getTime()
    ).format('MMM DD hh:mm:ss')}`;
  }

  private capitalizeFirstLetter(str: string): string {
    return str.charAt(0).toUpperCase() + str.slice(1);
  }

  // Notification broadcasting methods
  private broadcastActiveIncidentNotification(
    id: string,
    name: string,
    description: string,
    timestamp: any
  ): void {
    this.notification$.next({
      type: 'danger',
      id,
      content: this.buildNotificationContentString(
        'Active',
        name,
        description,
        timestamp
      ),
      icon: 'fa fa-exclamation fa-3x',
      onClick: () => this.activeIncidentNotificationClicked(id),
      onAction: () => this.goLiveIncident(id),
    });
  }

  private broadcastPendingIncidentNotification(
    id: string,
    name: string,
    description: string,
    timestamp: any
  ): void {
    this.notification$.next({
      type: 'warning',
      id,
      content: this.buildNotificationContentString(
        'Pending',
        name,
        description,
        timestamp
      ),
      icon: 'fa fa-exclamation fa-3x',
      onClick: () => this.pendingIncidentNotificationClicked(id),
    });
  }

  private broadcastProcallNotification(
    procallId: string,
    title: string,
    status: string,
    timestamp: any,
    exists: boolean
  ): void {
    this.notification$.next({
      type: 'danger',
      id: procallId,
      content: this.buildProcallContentString(status, title, timestamp),
      icon: 'fa fa-phone fa-3x',
      onClick: () => this.procallNotificationClicked(procallId),
      onAction: () => this.goLiveProcall(procallId),
    });
  }

  private broadcastTrackingNotification(
    item: any,
    missed: boolean,
    indistress: boolean
  ): void {
    const type = missed || indistress ? 'danger' : 'warning';
    this.notification$.next({
      type,
      id: item.id,
      content: this.buildTrackingContentString(
        item,
        item.title,
        item.end,
        missed,
        indistress
      ),
      icon: 'fa fa-wifi fa-3x',
      onClick: () => this.trackingNotificationClicked(item),
      onAction: () => this.goLiveTracking(item.id),
    });
  }

  private broadcastNotificationRemoval(id: string): void {
    this.notification$.next({ type: 'remove', id });
  }

  private broadcastCombinedTrackingAndProcallNotification(
    trackingData: any,
    procallData: any,
    exists: boolean
  ): void {
    this.notification$.next({
      type: 'danger',
      id: procallData.profileId,
      content: this.buildCombinedContentString(trackingData, procallData),
      icon: 'fa fa-phone fa-3x',
      onClick: () => this.procallNotificationClicked(procallData.id),
      onAction: () => this.goLiveProcall(procallData.id),
    });
  }

  // Click handlers (implement as needed)
  private activeIncidentNotificationClicked(id: string): void {
    /* ... */
  }
  private pendingIncidentNotificationClicked(id: string): void {
    /* ... */
  }
  private procallNotificationClicked(id: string): void {
    /* ... */
  }
  private trackingNotificationClicked(event: any): void {
    /* ... */
  }
  private goLiveIncident(id: string): void {
    /* ... */
  }
  private goLiveProcall(id: string): void {
    /* ... */
  }
  private goLiveTracking(id: string): void {
    /* ... */
  }

  //////////***************** new code for setting the color for incident building */

  // isPerimeterSafe() {
  //   return this.perimeterSafetyStatus === this.PERIMETER_SAFETY_STATUS_SAFE;
  // }
  // isPerimeterUnSafe() {
  //   return this.perimeterSafetyStatus === this.PERIMETER_SAFETY_STATUS_UNSAFE;
  // }
  // isPerimeterUnKnown() {
  //   return this.perimeterSafetyStatus === this.PERIMETER_SAFETY_STATUS_UNKNOWN;
  // }

  // public setSafetyStatusByStats(status: any): void {
  //   if (status === 'unknown') {
  //     this.perimeterSafetyStatus = this.PERIMETER_SAFETY_STATUS_UNKNOWN;
  //   } else if (status === 'unsafe') {
  //     this.perimeterSafetyStatus = this.PERIMETER_SAFETY_STATUS_UNSAFE;
  //   } else if (status === 'safe') {
  //     this.perimeterSafetyStatus = this.PERIMETER_SAFETY_STATUS_SAFE;
  //   }
  //   this.perimeterUserCountStatus = this.PERIMETER_USER_COUNT_STATUS_SOME_USERS;
  //   this.setMaterialFromStatus();
  // }

  // setMaterialFromStatus() {
  //   // if (this.perimeterSafetyStatus === this.perimeterSafetyStatusLast) return;
  //   this.perimeterSafetyStatusLast = this.perimeterSafetyStatus;
  //   // if (this.showIn3d) {
  //   let material = Cesium.Color.fromAlpha(
  //     Cesium.Color.LIGHTGRAY,
  //     this.transparency
  //   );
  //   // if (this.isPartOfBuilding) {
  //   if (true) {
  //     if (
  //       this.perimeterUserCountStatus ===
  //       this.PERIMETER_USER_COUNT_STATUS_SOME_USERS
  //     ) {
  //       if (this.isPerimeterUnSafe()) {
  //         material = Cesium.Color.fromBytes(170, 0, 0, 255);
  //       } else if (this.isPerimeterUnKnown()) {
  //         material = Cesium.Color.fromBytes(255, 230, 0, 255);
  //       }
  //     }
  //     this.setMaterial(material);
  //   } else {
  //     this.setMaterial(material);
  //   }
  //   // }
  // }
  // setMaterial(material: Color): void {
  //   this.material = material;
  //     const viewer = this.cores.getViewer();
  // if (viewer && viewer.entities) {
  //   // Find entity by ID or name
  //   const entity = viewer.entities.getById('');
  //   if (entity && entity.polygon) {
  //     entity.polygon.material = new ColorMaterialProperty(material);
  //   }
  // }
  //   // if (
  //   //   this.cesiumEntity !== undefined &&
  //   //   this.cesiumEntity.polygon !== undefined
  //   // ) {
  //   //   this.cesiumEntity.polygon.material = this.material;
  //   // }
  // }
}
